<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->
<div class="user-profile">
  <!-- User profile text-->
  <!-- ============================================================== -->
  <!-- Profile - style you can find in header.scss -->
  <!-- ============================================================== -->
  <div class="profile-text">
    <a [matMenuTriggerFor]="sdprofile" class="">
      {{UserData.Person.firstName}} {{UserData.Person.infix}} {{UserData.Person.lastName}}
      <i class="ti-angle-down font-12 m-l-5"></i>
    </a>
  </div>
  <mat-menu #sdprofile="matMenu" class="mymegamenu">
    <button (click)="logout()" [routerLink]="['/', 'authentication/logout']" mat-menu-item>
      <mat-icon>exit_to_app</mat-icon> Uitloggen
    </button>
  </mat-menu>
</div>

<mat-nav-list appAccordion>
  @for (menuitem of menuItems.getMenuitem(); track menuitem) {
    @if (isVisible(menuitem.visibleFor)) {
      <mat-list-item appAccordionLink routerLinkActive="selected"
        group="{{menuitem.state}}" (click)="scrollToTop()">

        @if (menuitem.type === 'link') {
          <a (click)="closeSidenav()" class="" appAccordionToggle [routerLink]="['/', menuitem.state]">
            <mat-icon>{{ menuitem.icon }}</mat-icon>
            <span>{{ menuitem.name }}</span>
            <span fxFlex></span>
            @for (badge of menuitem.badge; track badge) {
              <span class="label label-{{ badge.type }}">{{ badge.value }}</span>
            }
          </a>
        }

        @if (menuitem.type === 'extLink') {
          <a class="" appAccordionToggle href="{{menuitem.state}}">
            <mat-icon>{{ menuitem.icon }}</mat-icon>
            <span>{{ menuitem.name }}</span>
            <span fxFlex></span>
            @for (badge of menuitem.badge; track badge) {
              <span class="label label-{{ badge.type }}">{{ badge.value }}</span>
            }
          </a>
        }

        @if (menuitem.type === 'extTabLink') {
          <a class="" appAccordionToggle href="{{menuitem.state}}" target="_blank">
            <mat-icon>{{ menuitem.icon }}</mat-icon>
            <span>{{ menuitem.name }}</span>
            <span fxFlex></span>
            @for (badge of menuitem.badge; track badge) {
              <span class="label label-{{ badge.type }}">{{ badge.value }}</span>
            }
          </a>
        }

        <!-- Render parent “sub” only if it has at least one visible child -->
        @if (menuitem.type === 'sub' && hasVisibleChildren(menuitem)) {
          <a class="" appAccordionToggle href="javascript:;">
            <mat-icon>{{ menuitem.icon }}</mat-icon>
            <span>{{ menuitem.name }}</span>
            <span fxFlex></span>
            @for (badge of menuitem.badge; track badge) {
              <span class="label label-{{ badge.type }}">{{ badge.value }}</span>
            }
            <mat-icon class="dd-icon">keyboard_arrow_down</mat-icon>
          </a>

          <mat-nav-list class="sub-item">
            @for (childitem of menuitem.children; track childitem; let j = $index) {
              @if (isVisible(childitem.visibleFor)) {
                <mat-list-item routerLinkActive="selected">
                  @if (childitem.type === 'link') {
                    <a (click)="closeSidenav()"
                       [routerLink]="['/', menuitem.state, childitem.state]"
                       class="relative"
                       routerLinkActive="selected"
                       (click)="itemSelect[i]=j">{{ childitem.name }}</a>
                  }
                </mat-list-item>
              }
            }

            @for (childitem of menuitem.children; track childitem; let j = $index) {
              @if (childitem.type === 'subchild' && isVisible(childitem.visibleFor)) {
                <mat-list-item>
                  <a class="" href="javascript: void(0);" (click)="itemSelect[i]=j"
                     [ngClass]="j==itemSelect[i]? 'selected' : ''">
                    <span>{{ childitem.name }}</span>
                    <span fxFlex></span>
                    <mat-icon class="dd-icon">keyboard_arrow_down</mat-icon>
                  </a>

                  <mat-nav-list class="child-sub-item">
                    @for (child of childitem.subchildren; track child) {
                      @if (isVisible(child.visibleFor)) {
                        <mat-list-item routerLinkActive="selected">
                          <a (click)="closeSidenav()"
                             [routerLink]="['/', menuitem.state, childitem.state, child.state]"
                             routerLinkActive="selected">{{ child.name | translate }}</a>
                        </mat-list-item>
                      }
                    }
                  </mat-nav-list>
                </mat-list-item>
              }
            }
          </mat-nav-list>
        }

        @if (menuitem.type === 'saperator') {
          <div class="saperator text-muted">
            <span>{{ menuitem.name }}</span>
          </div>
        }
      </mat-list-item>
    }
  }
</mat-nav-list>
